import { DeleteModal } from "_components/modals";
import { CustomTable } from "_components/table/CustomTable";
import { alertActions, filterActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export { FiltersTableList };

/**
 * Tableau listant l'ensemble des filtres créés par l'utilisateur
 * @returns 
 */
function FiltersTableList () {

    const [data, setData] = useState([]);
    const filters = useSelector(state => state.filters?.list);
    const filter = useSelector(state => state.filters?.item);
    const dispatch = useDispatch();   
    const navigate = useNavigate();

    /* Gestion de l'affichage de la modale */
    const [show, setShow] = useState(false);
    const [filterToDelete, setFilterToDelete] = useState(null);

    const handleShowDeleteModal = (filter) => {
        setFilterToDelete(filter);
        setShow(true);
    };

    const handleCloseDeleteModal = () => {
        setShow(false);
    };

    /* Suppression d'un filtre après confirmation par l'utilisateur */
    async function handleDeleteFilter(item) {
        try {
            await dispatch(filterActions.deleteFilter(filterToDelete.id));

            const message = `Suppression du filtre "${filterToDelete.name}" réalisé avec succès`
            dispatch(alertActions.success({ message, showAfterRedirect: true }));
            //Après suppression, actualisation du store pour que le nouveau filtre disparaisse du tableau
            dispatch(filterActions.getAllFilters());
        } catch (error) {
            dispatch(alertActions.error(error));
        }
        setShow(false);
    }

    /**
     * Action de visualisation de filtre
     * @param {*} item 
     */
    async function viewAction(item) {
        dispatch(filterActions.setFilter(item))
    }

    /**
     * Edition d'un filtre existant
    *  Affectation du filtre au store et redirection vers le formulaire d'édition
     * @param {*} item 
     */
    function editAction(item) {
        dispatch(filterActions.setFilter(item))
        navigate(`edit/${item.id}`)
    }

    /**
     * Duplication d'un filtre 
     *  Toutes les données sont dupliquées sauf l'id et la date de création
     * @param {*} item 
     */
    async function duplicateAction(item) {
        try {
            const { creation_date, id, name, ...newFilter} = item
            newFilter.name = `${name} - copie`;

            const response = await dispatch(filterActions.createFilter(newFilter));

            // Vérification du statut de la réponse
            if (response.meta.requestStatus === 'rejected') {
                const errorMessage = response.error?.message || 'La duplication du filtre a échoué.';
                throw new Error(errorMessage);
            }  else {
                const message = `Duplication du filtre "${item.name}" réalisé avec succès`
                dispatch(alertActions.success({ message, showAfterRedirect: true }));
                //Après ajout, actualisation du store pour que le nouveau filtre apparaisse dans le tableau
                dispatch(filterActions.getAllFilters());
            }  
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    /**
     * Modification de l'objet reçu de l'api en tableau d'objets
     */
    useEffect(() => {
        if (filters) {
            const values = Object.entries(filters).map(([key, value]) => {
                // Créer une nouvelle copie de l'objet avec l'ID ajouté si absent
                if (!value.hasOwnProperty('id')) {
                    return { ...value, id: key };
                }
                return { ...value };
            });
            setData(values);
        }
    }, [filters]);

    useEffect(() => {
        if(filter){
            dispatch(filterActions.clearFilter())        
        }
    }, [])

    const headers = [
        { label: 'Nom', key: 'name', type: 'string', canToggle: false, visible: true},
        { label: 'Description', key: 'description', type: 'string', canToggle: false, visible: true },
        { label: '', key: 'view', type: 'action', action: viewAction, icon: 'loupeOutlined', canToggle: false, visible: true, title: 'afficher le détail' },
        { label: '', key: 'edit', type: 'action', action: editAction, icon: 'editOutlined', canToggle: false, visible: true, title: 'modifier ce filtre' },
        { label: '', key: 'duplicate', type: 'action', action: duplicateAction, icon: 'contentCopyOutlined', canToggle: false, visible: true, title: 'dupliquer ce filtre' },        
        { label: '', key: 'delete', type: 'action', action: handleShowDeleteModal, icon: 'deleteForeverOutlined', canToggle: false, visible: true, title: 'supprimer ce filtre' },
    ]

     return (
        <>
            <div className="custom-table-container">
                <div className={'flex justify-between items-center'}>
                    <div className="flex items-center">
                        <span className={'title-customtable'}>{data.length}</span>
                        <span className={'small-title-customtable'}> Filtre{data.length > 1 ? 's' : ''} </span>
                    </div>
                </div>
                <div className={"my-4 "}>
                    <CustomTable data={data} headers={headers} maxHeight={'75vh'}/>
                </div>
            </div>
            <DeleteModal
                show={show}
                handleClose={handleCloseDeleteModal}
                handleDelete={handleDeleteFilter}
                entityName={`le filtre "${filterToDelete?.name ?? ''}"`}
            />
        </>

    )
}